const AuthRoutes = {
  login:"/Account/Login",
  logout:"/Account/Logout",
  getTrainsById:"/Train/GetTrainStationsByTrainId",
  getTrains:"/Train/GetTrains",
  getLocomotive:"/Train/GetLocomotiveNumbers?offset=0&limit=1000",
  getLiveTrain:"/Train/GetLiveTrainsForDashboard?offset=0&limit=1000",
  allocateLocomotive:"/Train/SetLocomotiveAllocation",
  Complete:"/Train/CompleteRide",
  allocateLocomotiveList:"/Train/GetLocomotives?offset=0&limit=1000",
  updateLocomotive:"/Train/UpdateLocomotive",
  deleteLocomotive:"/Train/DeleteLocomotiveById",
  addLocomotive:"/Train/SetLocomotive",
  allocationList:"/Train/GetLocomotiveAllocations",
  updatetTrainStatus:"/Train/UpdateTrainStatusById",
  updateTrainById:"/Train/UpdateTrainById",
  deleteTrain:"/Train/DeleteTrainById",
  addTrain:"/Train/SetTrain",
  trainRoutes:"/Train/GetTrainStationsByTrainId",
  deleteTrainRoute:"/Train/DeleteTrainStationByTrainId",
  getStations:'/Station/GetStations',
  addStation:"/Station/SetStation",
  updateStation:"/Station/UpdateStationById",
  deleteStation:"/Station/DeleteStationById",
  addTrainRoute:"/Train/SetTrainSchedule",
  updateTrainRoute:"/Train/UpdateTrainStationByTrainId",
  createNotification :'/PushNotification/Create',
  getNotification:"/PushNotification/GetNotifications",
  deleteNotification:"/PushNotification/DeleteNotificationById",
  getAnalytics: "/Train/GetLocomotiveAnalytics",
  getDashboard: "/Train/GetDashboardDetails",
};

export default AuthRoutes;